import AccountType from "@/domain/AccountType"

export const PostOfficeAreaOperator = new AccountType(0, "Оператор района")
export const Admin = new AccountType(1, "Администратор почты")

export const PostOfficeOperator = new AccountType(3, "Оператор отделения")
export const PostOfficeRegionAdmin = new AccountType(4, "Администратор филиала")
export const Shipox = new AccountType(6, "Шипокс")

export const GlobalAdmin = new AccountType(100, "Суперадминистратор")
export const WebClient = new AccountType(200, "Веб клиент")
